export const FETCH_CASES_URL = 'cases';
